import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '../../../../Text';
import styles from '@dtsl/css-input/dist/index.module.css';
import Error from '@dtsl/icons/dist/icons/react/Error';
import Success from '@dtsl/icons/dist/icons/react/Success';

/* eslint-disable react/display-name */
const ValidationMessage = /*#__PURE__*/React.memo(props => {
  const {
    isError,
    isSuccess,
    validationText,
    id,
    accessibleSuccessText,
    accessibleErrorText
  } = props;
  const getIcon = () => isError ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles['sib-sr-only']
  }, " ", accessibleErrorText), /*#__PURE__*/React.createElement(Error, {
    height: 16,
    width: 16,
    "aria-hidden": "true"
  })) : isSuccess ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles['sib-sr-only']
  }, " ", accessibleSuccessText), /*#__PURE__*/React.createElement(Success, {
    height: 16,
    width: 16,
    "aria-hidden": "true"
  })) : null;
  return validationText && (isError || isSuccess) ? /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    tag: "span",
    color: isError ? 'var(--sib-color_negative-press)' : isSuccess ? 'var(--sib-color_positive-hover)' : 'var(--sib-color_content-secondary)',
    className: styles['sib-input-validation'],
    "aria-live": "assertive",
    id: `${id}-validationText`,
    style: {
      marginTop: '4px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['sib-input-validation--icon']
  }, " ", getIcon()), /*#__PURE__*/React.createElement("span", null, validationText)) : null;
});
ValidationMessage.propTypes = {
  isSuccess: PropTypes.bool,
  isError: PropTypes.bool,
  validationText: PropTypes.string,
  id: PropTypes.string,
  accessibleErrorText: PropTypes.string,
  accessibleSuccessText: PropTypes.string
};
export default ValidationMessage;